import React, { useCallback, useContext, useEffect, useState } from "react";
import UserService from "../services/user.service";
import UserBusinessInterface from "../interfaces/UserBusinessInterface";
import { Autocomplete, GoogleMap, Marker } from "@react-google-maps/api";
import NotyfContext from '../contexts/NotyfContext';
import AuthService from "../services/auth.service";

// Components by MUI
import { Alert, AlertTitle, Box, Breadcrumbs, Button, Card, CardContent, CardHeader, Container, Grid, Link, TextField, Typography } from "@mui/material";

// CSS
import "../App.css";

// interface ProfileProps {
// 	id?: string|undefined;
// };

const Profile: React.FC = () => {
	const notyf = useContext(NotyfContext);
	const currentUser = AuthService.getCurrentUser();
	const [user, setUser] = useState<UserBusinessInterface>();
	// const [loadingUser, setLoadingUser] = useState(true);

	const [address, setAddress] = useState<string>("");
	const [addressTemp, setAddressTemp] = useState<string>(user?.address?.formatted_address ?? "");
	const [autocompleteAddress, setAutocompleteAddress] = useState<any>(null);

	const getProfileAddress = useCallback(() => {
		UserService.getProfileAddress(currentUser ?? "")
		.then((response) =>{
			setUser(response.data);
			setAddressTemp(response?.data?.address?.formatted_address ?? "");
			setAddress(response?.data?.address?.formatted_address ?? "");
		}).catch((error) => {
			if (JSON.stringify(error).includes("401")) {
				AuthService.Logout();
			}
			
			console.log(error);
		});
	}, [currentUser]);

	const updateProfileAddress = () => {
		UserService.setProfileAddress(currentUser ?? "", user?.address)
		.then((response) => {
			notyf.success("Endereço de origem padrão atualizado com sucesso.");
			// console.log(response);
		}).catch((error) => {
			notyf.error("Ocorreu um erro ao atualizar o endereço de origem padrão.");
			
			if (JSON.stringify(error).includes("401")) {
				AuthService.Logout();
			}
		});
	};

	useEffect(() => {
		getProfileAddress();
	}, [getProfileAddress]);

	// const [map, setMap] = React.useState(null);
	const onLoad = React.useCallback(function callback(map) {
		// const bounds = new window.google.maps.LatLngBounds();
		// map.fitBounds(bounds);
		// setMap(map)
	}, []);

	const onUnmount = React.useCallback(function callback(map) {
		// setMap(null)
	}, []);

	// Autocomplete Address
	const onLoadAutocompleteAddress = (autocomplete) => {
		// console.log('autocomplete: ', autocomplete)
		setAutocompleteAddress(autocomplete);
	};

	const onPlaceChangedAddress= () => {
		if (autocompleteAddress !== null && autocompleteAddress !== undefined) {
			let address = autocompleteAddress.getPlace();
			var lat = address.geometry.location.lat(), 
			lng = address.geometry.location.lng();

			// console.log(lat + " - " + lng);
			setAddress(address.formatted_address);
			setAddressTemp(address.formatted_address);
			setUser((prevState) => ({
				...prevState,
				address: {
					type: "Point",
					coordinates: [lng, lat],
					formatted_address: address.formatted_address
				}
			})) 
		} else {
			console.log('Autocomplete is not loaded yet!')
		}
	}

	return (
		<>
			<Box m={2}>
				<Breadcrumbs aria-label="breadcrumb">
					<Link underline="hover" color="inherit" href="/">
						Página inicial
					</Link>
					<Typography color="text.primary" aria-current="page">Meu perfil</Typography>
				</Breadcrumbs>
			</Box>

			<Container>
				<Grid container mb={10}>
					<Grid item xs={12} md={12} lg={12}>
						<Box mt={2} mb={2}>
							<Card>
								<CardHeader
									title={"Meu perfil"}
								/>
								<CardContent>
									{user !== undefined && (
										<>
											<Grid container spacing={3}>
												<Grid item xs={12} md={12} lg={12}>
													<Alert severity={"info"}>
														<AlertTitle>Aviso!</AlertTitle>
														Em caso de alguma inconsistência no perfil, entre em contato com o suporte.
													</Alert>
												</Grid>
												<Grid item xs={12} md={6} lg={6}>
													<TextField
														label={"Nome da empresa"}
														variant={"outlined"}
														fullWidth
														disabled
														defaultValue={user.companyName}
													/>
												</Grid>
												<Grid item xs={12} md={6} lg={6}>
													<TextField
														label={"E-mail"}
														variant={"outlined"}
														fullWidth
														disabled
														defaultValue={user.email}
													/>
												</Grid>
												<Grid item xs={12} md={6} lg={6}>
													<TextField
														label={"Telefone"}
														variant={"outlined"}
														fullWidth
														disabled
														defaultValue={user.phone}
													/>
												</Grid>
												<Grid item xs={12} md={6} lg={6}>
													<TextField
														label={"Nome de usuário"}
														variant={"outlined"}
														fullWidth
														disabled
														defaultValue={user.username}
													/>
												</Grid>
											</Grid>
										</>
									)}
								</CardContent>
							</Card>
						</Box>
					</Grid>

					
					<Grid item xs={12} md={12} lg={12}>
						<Box mt={2} mb={2}>
							<Card>
								<CardHeader
									title={"Meu endereço de origem padrão"}
								/>
								<CardContent>
									{user?.address === undefined || user.address === null ? <>
										<Box mt={2}>
											<Alert severity="info">Você ainda não definiu um endereço de origem padrão.</Alert>
										</Box>
									</> : <></>}

									<Box mt={2}>
										<Grid container spacing={2}>
											<Grid item lg={8} md={8} xs={12}>
												<Autocomplete
													onLoad={onLoadAutocompleteAddress}
													onPlaceChanged={onPlaceChangedAddress}
													fields={[
														"formatted_address",
														"geometry",
														"geometry.location",
													]}
												>
													<TextField
														fullWidth
														label="Endereço de origem padrão"
														type="text"
														variant="outlined"
														placeholder="Digite o seu endereço de origem padrão"
														autoComplete={"off"}
														error={addressTemp === "" || addressTemp === undefined}
														helperText={addressTemp === "" && "Digite o endereço de origem padrão"}
														// defaultValue={user?.address?.formatted_address}
														value={addressTemp}
														onChange={(event) => {
															setAddressTemp(event.target.value);
														}}
														onFocus={(event) => {
															event.target.autocomplete = "whatever";
														}}
													/>
												</Autocomplete>
											</Grid>
											<Grid item lg={4} md={4} xs={12}>
												<TextField 
													fullWidth 
													label="Complemento"
													type="text"
													variant="outlined"
													placeholder="Digite o complemento"
													autoComplete={"off"}
													value={user?.address?.addressLine2 || ""}
													error={user?.address?.addressLine2 === "" || user?.address?.addressLine2 === undefined}
													onChange={(event) => {
														event.persist();
														setUser((prevState) => ({
															...prevState,
															address: {
																type: "Point",
																coordinates: [user?.address?.coordinates[0] ?? 0, user?.address?.coordinates[1] ?? 0],
																formatted_address: user?.address?.formatted_address ?? "",
																addressLine2: event.target.value ?? ""
															}
														}))
													}}
												/>
											</Grid>
										</Grid>
									</Box>

									<Box mt={2}>
										<Button
											disabled={addressTemp === "" || address === ""}
											variant={"contained"}
											onClick={() => updateProfileAddress()}
										>
											Salvar
										</Button>
									</Box>

									<Box mt={2}>
										<GoogleMap
											mapContainerStyle={{width: "100%", height: "40vh"}}
											center={
												user?.address?.coordinates !== undefined && user.address.coordinates.length > 0
												? {
													lat: user.address.coordinates[1],
													lng: user.address.coordinates[0]
												}
												: {
													lat: -30.07, 
													lng: -51.25
												}
											}
											zoom={
												user?.address?.coordinates !== undefined && user.address.coordinates.length > 0
												? 14
												: 9
											}
											onLoad={onLoad}
											onUnmount={onUnmount}
											options={{
												zoomControlOptions: {
													position: google.maps.ControlPosition.RIGHT_CENTER
												}
											}}
										>
											{user?.address !== undefined 
											&& user.address !== null
											&& user.address.coordinates !== undefined
											&& user.address.coordinates.length > 0 && 
												<Marker
													position={{
														lat: user.address.coordinates[1],
														lng: user.address.coordinates[0]
													}}
												/>
											}
										</GoogleMap>
									</Box>
								</CardContent>
							</Card>
						</Box>
					</Grid>
				</Grid>
			</Container>
		</>
	);
};

export default Profile;
